/**
 * Product gallery video: play the video when its slide becomes the active
 * slide of the main gallery, and pause + rewind it once the gallery has moved
 * on. Driven by Swiper's own slide events (see assets/product-oja.js, which
 * creates the Swiper instance on [data-gallery-main]). If Swiper never loads,
 * falls back to a visibility observer.
 * Videos are muted + playsinline, which is what lets browsers autoplay them.
 */
(function () {
  function play(video) {
    video.muted = true;
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      // Browser refused autoplay (e.g. data saver / low power mode):
      // fall back to the native play control so it is never stuck.
      attempt.catch(function () {
        video.controls = true;
      });
    }
  }

  function stop(video) {
    if (video.paused) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {}
  }

  function initGalleryVideos(root) {
    if (root.dataset.ojaVideoInit === 'true') return;

    var mainEl = root.querySelector('[data-gallery-main]');
    var videos = Array.prototype.slice.call(root.querySelectorAll('.product-gallery__main video'));
    if (!mainEl || !videos.length) return;
    root.dataset.ojaVideoInit = 'true';

    function activeVideoOf(swiper) {
      var slide = swiper.slides && swiper.slides[swiper.activeIndex];
      return slide ? slide.querySelector('video') : null;
    }

    function useSwiper(swiper) {
      function startActive() {
        var active = activeVideoOf(swiper);
        if (active) play(active);
      }

      function stopInactive() {
        var active = activeVideoOf(swiper);
        videos.forEach(function (video) {
          if (video !== active) stop(video);
        });
      }

      // Start as the slide begins to move in; stop the others once the move ends,
      // so the outgoing video does not jump back to its first frame mid-slide.
      swiper.on('slideChange', startActive);
      swiper.on('slideChangeTransitionEnd', stopInactive);

      startActive();
    }

    function useObserver() {
      if (!('IntersectionObserver' in window)) {
        videos.forEach(play);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              play(entry.target);
            } else {
              stop(entry.target);
            }
          });
        },
        { threshold: [0, 0.6, 1] }
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });
    }

    // Swiper is loaded asynchronously by product-oja.js; wait for it.
    if (mainEl.swiper) {
      useSwiper(mainEl.swiper);
      return;
    }

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (mainEl.swiper) {
        window.clearInterval(timer);
        useSwiper(mainEl.swiper);
      } else if (tries >= 100) {
        window.clearInterval(timer);
        useObserver();
      }
    }, 100);
  }

  document.querySelectorAll('[data-product-page]').forEach(initGalleryVideos);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-product-page]');
    if (root) initGalleryVideos(root);
  });
})();